module.exports = __webpack_public_path__ + "static/media/logo--round-mobile.ada219e0.png";